export const defaults = {
  CUSTOM_PEERING_NAME: "Untitled Custom Peering",
  SPACE_PEERING: "Untitled Space Peering"
}
